import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Drawer, Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Logo from "./Logo";
import NavPanel from "./NavPanel";
import NavSearch from "./NavSearch";
import { toggleCollapsedNav, onMobileNavToggle } from "redux/actions/Theme";
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "constants/ThemeConstant";
import utils from "utils";
import avatar from "../../assets/svg/avatar.jpeg";
import { FaRegBell, FaSearch, FaCog } from "react-icons/fa";
import { BsBell } from "react-icons/bs";
import MyAccount from "../reusable-components/My-Account";
import {
  fetchmanageUserRequest,
  getUserDetailData,
  getUserDetailsRequest,
} from "redux/reducers/manageUsers";
import { useDispatch, useSelector } from "react-redux";
import { getLocationListState ,fetchLocationListRequest} from "redux/reducers/location";
import { fetchLocationAccountListRequest } from "redux/reducers/account";
import { fetchPermissionListRequest } from "redux/reducers/permissions";
const { Header } = Layout;

export const HeaderNav = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
    direction,
  } = props;
  const [searchActive, setSearchActive] = useState(false);
  const [visible, setVisible] = useState(false);
  const [userData, setUserData] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserDetailsRequest({ id: localStorage.getItem("user") }));
    dispatch(fetchLocationListRequest())
  }, []);
  const getuserData = useSelector(getUserDetailData);
  useEffect(() => {
    setUserData(getuserData?.data?.data);
    if (getuserData?.data?.data?.name !== undefined) {
    localStorage.setItem("UserName", getuserData?.data?.data?.name);
    }
  }, [getuserData]);
  const [buildingList, setBuildingList] = useState([]);
  const BuildingList = useSelector(getLocationListState);
  useEffect(() => {
    if (!BuildingList?.data?.data?.length) return setBuildingList([]);
    const data = BuildingList?.data?.data?.filter(
      (value) => value.isSpecial === true
    );
    if (data.length > 0) {
      localStorage.setItem(
        "location1",
        JSON.stringify({ name: data[0]?.name, value: data[0]?._id })
      );
      localStorage.setItem(
        "location2",
        JSON.stringify({ name: data[1]?.name, value: data[1]?._id })
      );
    }
  }, [BuildingList]);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  const handleCallback = (childData) => {
    onClose();
  };

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === "dark" ? "#00000" : "#ffffff"
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  });
const UserData = async () => {
    if (!userDetail.data) return ;
    const locations = await userDetail?.data?.data?.location;
    const primaryLocation = await userDetail?.data?.data?.primaryLocation;
    let selectedlocations = [primaryLocation, ...locations];
    // let totallocations = selectedlocations?.map((e) => ({
    //   value: e?._id,
    //   name: e?.name,
    // }));
    let totallocations = [];
    selectedlocations?.map((e) => {
      if(e.isActive){
        totallocations.push({
          value: e?._id,
          name: e?.name,
        })
      }
    });
    let jsonObject = totallocations.map(JSON.stringify);
    let uniqueSet = new Set(jsonObject);
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    // setSelectedLocation(uniqueArray);
    // setlocation(uniqueArray);
    if (uniqueArray) {
      localStorage.setItem("assingedL", JSON.stringify(uniqueArray));
    }
  };
  const userDetail = useSelector(getUserDetailData);
  useEffect(() => {
    UserData();
  }, [userDetail]);

  const clickHandler = () => {
    UserData();
    dispatch(fetchPermissionListRequest());
    dispatch(fetchLocationListRequest())
    dispatch(fetchLocationAccountListRequest())
    dispatch(fetchmanageUserRequest())
  };
  const justClick = (e) => {
    if (e.keyCode === 13 && e.ctrlKey) {
      clickHandler();
    }
  };
  useEffect(() => {
    document.addEventListener("keydown", justClick);
  },[]);

  return (
    <Header
      className={`app-header ${navMode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        {/* <Logo logoType={navMode} /> */}
        {/* {navCollapsed || isMobile ? (
          <MenuUnfoldOutlined className="nav-icon" />
        ) : (
          <MenuFoldOutlined className="nav-icon" />
        )} */}
        <ul className="ant-menu ant-menu-root ant-menu-horizontal">
          {isNavTop && !isMobile ? null : (
            <li
              className="ant-menu-item ant-menu-item-only-child"
              onClick={() => {
                onToggle();
              }}
            >
              {navCollapsed || isMobile ? (
                <MenuUnfoldOutlined className="nav-icon" />
              ) : (
                <MenuFoldOutlined className="nav-icon" />
              )}
            </li>
          )}
        </ul>
        <div className="nav" style={{ width: "100%" }}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              {isNavTop && !isMobile ? null : (
                <li className="ant-menu-item ant-menu-item-only-child">
                  <Logo logoType={navMode} />
                </li>
              )}
            </ul>
                <span>
                  <button onClick={clickHandler}style={{display:"none"}} ></button>
                </span>
          </div>
          <div className="nav-right">
            {/* <NavPanel direction={direction} /> */}
          </div>
          <NavSearch active={searchActive} close={onSearchClose} />
          {/* <a>
            <img src="" width="30px" className="rounded-circle" />
          </a> */}
          <div className="ms-auto top-head-nav">
            <div className="d-flex thn-bx">
              {/* <div className="top-head-btn top_search_box" href="#">
                <div className="t-srch-cnt">
                  <form method="post">
                    
                    <FaSearch
                      size={16}
                      className="fa fa-search search-icon-t"
                    />
                    <input className placeholder="Search..." />
                  </form>
                </div>
                <a href="#">
                  <FaSearch size={24} className="fa fa-search" />
                  
                </a>
              </div> */}
              {/* <a href="#" className="top-head-btn setti">
                <i className="fa fa-cog" aria-hidden="true" />
                <FaCog size={20} className="fa fa-cog" />
              </a> */}
              {/* <a
                className="top-head-btn noti"
                data-bs-toggle="offcanvas"
                href="#notification-offcanvas"
                role="button"
              >
                <BsBell size={20} className="fa fa-bell-o" />
                <i className="fa fa-bell-o" aria-hidden="true" />
              </a> */}
              <div className="dropdown" style={{ marginTop: "2px" }}>
                <a
                  className
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => {
                    showDrawer();
                  }}
                >
                  <img
                    src={getuserData?.data?.data?.profilePicture || avatar}
                    width="39px"
                    className="rounded-circle"
                    alt
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Edit My Account Info*/}
      <Drawer
        title={"My Account"}
        placement="right"
        onClose={onClose}
        visible={visible}
        className="ant-drawer-small"
      >
        <MyAccount parentCallback={handleCallback} data={userData} />
      </Drawer>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  } = theme;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNav);
